<div class="d-flex flex-column pe-0 pe-sm-10 my-5">
  <h5 class="mb-1" *ngIf="title">{{title}}</h5>
  <span *ngIf="subTitle">{{subTitle}}</span>
</div>
